import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { AnalyticsBaseChartComponent } from "app/analytics/component/analytics-base-chart/analytics-base-chart.component";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
  UserPermissions,
} from "app/shared";
import {
  AppUsageConfig,
  UserSessionsConfig,
} from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "app-usage-details",
  templateUrl: "./app-usage-details.component.html",
  standalone: false,
})
export class AppUsageDetailsComponent
  extends BaseDetailsLogic<AppUsageConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, AppUsageConfig, tooltipCoordinator);
  }

  //TODO: Analytics:  Add TimePeriod select for sessionExpirationPeriod, see manuals-downloaded-details.component.ts and html, also add to html

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
  }

  get selectedPermission(): number | UserPermissions {
    return this.config.userPermission as UserPermissions;
  }

  set selectedPermission(value: number | UserPermissions) {
    this.config.userPermission = value;
    this.detectSettingsChange();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see app usage data for that range. For example, you can look at usage in the last week, month, or year. This helps you understand when people are using the app most.",
      userPermission:
        "Select the type of user permission to filter results. For example, you can choose to see data only for administrators, editors, or regular users. This helps you focus on the activity of specific user groups."
    };
  }
}
